import {Platform} from 'react-native';
import {api} from '@/lib/api';

// Confidant folder operations
export async function createSubfolder(parentFolderId: string, name: string, organization: string) {
    const res = await api.post(`/confidant/folders/${parentFolderId}/subfolder`, {name, organization});
    return res.data;
}

export async function updateSubfolder(folderId: string, name: string, organization: string) {
    const res = await api.patch(`/confidant/folders/${folderId}`, {name, organization});
    return res.data;
}

export async function deleteSubfolder(folderId: string, organization: string) {
    const res = await api.delete(`/confidant/folders/${folderId}`, {data: {organization}});
    return res.data;
}

// Confidant media operations
export async function createMediaInSharedFolder(data: {
    name?: string;
    organization: string;
    originalContentType: string;
    originalSuffix: string;
    folder: string;
    sorting?: number;
}, previewImageUri?: string) {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
        if (value !== undefined) {
            formData.append(key, String(value));
        }
    });

    if (previewImageUri) {
        if (Platform.OS === 'web') {
            const response = await fetch(previewImageUri);
            const blob = await response.blob();
            formData.append('previewImage', blob, 'preview.jpg');
        } else {
            formData.append('previewImage', {
                uri: previewImageUri,
                type: 'image/jpeg',
                name: 'preview.jpg',
            } as any);
        }
    }

    const res = await api.post('/confidant/media', formData, {
        headers: {'Content-Type': 'multipart/form-data'}
    });
    return res.data;
}

export async function getConfidantUploadId(mediaId: string) {
    const res = await api.get(`/confidant/media/${mediaId}/upload-id`);
    return res.data.uploadId as string;
}

export async function getConfidantSignedUrl(mediaId: string) {
    const res = await api.get(`/confidant/media/${mediaId}/url`);
    return res.data.signedUrl as string;
}

export async function finalizeConfidantUpload(mediaId: string) {
    const res = await api.post(`/confidant/media/${mediaId}/finalize`);
    return res.data;
}

export async function getConfidantMultipartUrl(mediaId: string, uploadId: string, part: number) {
    const res = await api.get(`/confidant/media/${mediaId}/upload-id/${uploadId}/url/${part}`);
    return res.data.signedUrl as string;
}

export async function finalizeConfidantMultipartUpload(
    mediaId: string,
    uploadId: string,
    parts: {PartNumber: number; ETag: string}[]
) {
    const res = await api.post(`/confidant/media/${mediaId}/upload-id/${uploadId}/finalize`, {parts});
    return res.data;
}

export async function updateConfidantMedia(mediaId: string, data: {name?: string; description?: string}) {
    const res = await api.patch(`/confidant/media/${mediaId}`, data);
    return res.data;
}

export async function deleteConfidantMedia(mediaId: string) {
    const res = await api.delete(`/confidant/media/${mediaId}`);
    return res.data;
}
